import React, { useEffect, useState } from 'react'


const alphabet = ["R1", "R2", "R3", "R4"];
let questionNumber = 1

let checkResponse = false
export const QuestionCardV4 = ({
	data = {
		question: "",
		options: [
			{
				id: 1,
				text: ""
			},
			{
				id: 2,
				text: "",
				isCorrect: true
			},
			{
				id: 3,
				text: ""
			},
		]
	},
	actionGameQuestion = () => {

	} }) => {
	const [selectAnswer, setSelectAnswer] = useState(-1)
	const [isNextQuestion, setIsNextQuestion] = useState(false)
	const [statusResponse, setStatusResponse] = useState(0)

	const setSelectQuestion = (id) => {
		const questionIsCorrect = data.options.find((opt) => opt.id === id)
		if (!questionIsCorrect) {
			return
		}
		if (checkResponse) {
			return
		}
		checkResponse = true
		if (questionIsCorrect.isCorrect) {
			setStatusResponse(1)
		} else {
			setStatusResponse(2)
		}
		setSelectAnswer(id)
		setIsNextQuestion(true)
		setTimeout(() => {
			questionNumber++
		}, 1000);
	}

	const nextQuestion = () => {
		checkResponse = false
		actionGameQuestion(statusResponse)
		setSelectAnswer(-1)
		setStatusResponse(0)
		setIsNextQuestion(false)
	}

	useEffect(() => {
		let time = null
		if (isNextQuestion) {
			setTimeout(() => {
				nextQuestion()
			}, 1000);
		}
		return () => {
			clearTimeout(time)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isNextQuestion])

	return (
		<>
			<div className='fixed z-20 w-full h-full bottom-0 animate__animated  animate__fadeIn flex items-center justify-center'>
				<div className="min-h-[auto] md:h-auto w-[555px] md:w-[900px] gradiantBlueClient flex flex-col justify-between items-center border-2 rounded-[18px] md:rounded-[36px]">
					<div className="w-full min-h-[48px] md:min-h-[80px] bg-red_primary rounded-t-[16px] md:rounded-t-[34px] flex justify-center items-stretch py-2 md:py-4 px-4 md:px-8">
						<div className='w-[90%] bg-[#ffffffcc] py-6 px-8 md:px-10 rounded-2xl'>
							<p className="text-black text-[14px] md:text-[20px] font-semibold">{data.question}</p>
						</div>
						<div className='w-[10%]'>
							<p className='text-white text-[14px] md:text-[16px] font-bold text-end'>{questionNumber > data.options.length ? questionNumber = 1 : questionNumber}/{data.options.length}</p>
						</div>
					</div>
					<div className="w-full min-h-[164px] max-h-[300px] h-full flex justify-center items-center py-2 md:py-6 px-4 md:px-8">
						<div className="w-full h-full flex flex-col justify-center items-center">
							<div className='h-auto pb-4'>
								<p className='text-white text-[14px] md:text-[16px] font-bold'>Selecciona tu respuesta</p>
							</div>
							<div className='h-full w-full flex flex-wrap justify-center items-stretch gap-2'>
								{data.options.map((question, index) => (
									<OptionsQuestion
										key={`${index}-questionGame`}
										indexLetter={index}
										selectAnswer={selectAnswer}
										typeResponse={statusResponse}
										action={setSelectQuestion}
										text={question.text}
										id={question.id}
									/>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);

}

const OptionsQuestion = ({ indexLetter = 0, selectAnswer = -1, action = () => { }, text = "", id = 0, typeResponse = 0 }) => {
	let styleQuestion = { back: "bg-white", colorText: "text-black", colorLetter: "text-red_primary" }

	if (typeResponse === 1 && id === selectAnswer) {
		styleQuestion = { back: "bg-[#22C55E]", colorText: "text-white", colorLetter: "text-white" }
	}
	if (typeResponse === 2 && id === selectAnswer) {
		styleQuestion = { back: "bg-[#DF3C3C]", colorText: "text-white", colorLetter: "text-white" }
	}
	return (
		<>
			<div onClick={() => { action(id) }} className={`${styleQuestion.back} w-[49%]  rounded-[14px] flex items-center p-2 gap-2 md:gap-4`}  >
				<div className="w-auto ">
					<p className={`${styleQuestion.colorLetter} font-bold text-[18px] md:text-[32px]`}>{alphabet[indexLetter]}:</p>
				</div>
				<div className="w-full">
					<p className={`${styleQuestion.colorText} font-medium text-center text-[10px] md:text-[16px]`}>{text}</p>
				</div>
			</div>
		</>
	)
}
